import gql from 'graphql-tag';

export const UPDATE_AUTH_MUTATION = gql `
mutation updateAccount($firstName: String,$lastName: String){
  updateAccount(firstName: $firstName, lastName: $lastName){
    success
  }
}
`